import { WithAuth } from "@/hoc";
import { Stack } from "@chakra-ui/react";
import { PageHeading } from "barte-design-system";
import { ApiKeys } from "./api-keys";
import { WebHooks } from "./web-hooks";
import { useNavigate } from "react-router-dom";
const Integracao = () => {
  const navigate = useNavigate();
  return (
    <Stack spacing={10}>
      <PageHeading
        title="Integrações"
      />
      <ApiKeys />
      <WebHooks />
    </Stack>
  );
};

export default WithAuth(Integracao);
